import { render, staticRenderFns } from "./SectionRowText.vue?vue&type=template&id=52b700ff&"
import script from "./SectionRowText.vue?vue&type=script&lang=ts&"
export * from "./SectionRowText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports